import { FirebaseApp, FirebaseOptions, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseFallBackData: FirebaseOptions = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

let app: FirebaseApp | null = null;
//If an firebase app hasn't already been created
export default function firebaseAuth(
  companyFireBaseSettings = firebaseFallBackData,
) {
  try {
    if (!companyFireBaseSettings) return null;
    if (!app) {
      app = initializeApp(companyFireBaseSettings);
    }
    return getAuth(app);
  } catch (error) {
    console.error("Firebase auth initialization failed:", error);
    return null;
  }
}
